"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TouchHandlerRotateBoxState = void 0;
var tslib_1 = require("tslib");
var rotate_box_helper_1 = require("../rotate-box-helper");
var touch_handler_state_base_1 = require("./touch-handler-state-base");
var TouchHandlerRotateBoxState = (function (_super) {
    tslib_1.__extends(TouchHandlerRotateBoxState, _super);
    function TouchHandlerRotateBoxState() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TouchHandlerRotateBoxState.prototype.onTouchStart = function (evt) {
        this.rotateBoxHelper = new rotate_box_helper_1.RotateBoxHelper(this.handler.control, this.handler.boxVisualizerManager.resizeBoxVisualizer);
        this.rotateBoxHelper.start(evt);
    };
    TouchHandlerRotateBoxState.prototype.onTouchMove = function (evt) {
        this.rotateBoxHelper.move(evt);
        return false;
    };
    TouchHandlerRotateBoxState.prototype.onTouchEnd = function (evt) {
        this.rotateBoxHelper.end(evt);
        this.handler.switchToDefaultState();
    };
    return TouchHandlerRotateBoxState;
}(touch_handler_state_base_1.TouchHandlerStateBase));
exports.TouchHandlerRotateBoxState = TouchHandlerRotateBoxState;
